import styled from 'styled-components';

import { Media } from '../../assets/Mixins.style';

export const Label = styled.span`
  display: inline-block;
  margin: 0 25px;
  color: ${(props) => props.theme.color};
  font-size: 22px;
  font-weight: 400;
  cursor: default;

  ${Media.xlg`
    margin: 0 15px;
    font-size: 18px;
  `}

  ${Media.lg`
    margin: 0 5px;
    font-size: 14px;
  `}
`;
